/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { useFormContext } from 'react-hook-form';
import { forwardRef } from "react";
import formComponents from "../forms";

const TemplateForm = forwardRef((props, ref) => {
  const methods = useFormContext();
  const { template, inputDir, section } = props;
  const ComponentToRender = formComponents[template.label.replace(/[\s:-]+/g, '')];
  // If the component is not found, return a message
  if (!ComponentToRender) {
    return <div>Component not found for template {template.title}</div>;
  }
  // Render the form using the form context
  return <ComponentToRender {...props} methods={methods} inputDir={inputDir} section={section} />;
});

export default TemplateForm;